import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { EyeOutlined, LogoutOutlined } from '@ant-design/icons';
import { useImpersonation } from '../admin/impersonation';
import { useNotionMessages } from './notion/useNotionMessages';
import './ImpersonationBanner.css';

/**
 * Bandeau affiché pendant une session « connecté en tant que » (admin).
 * Permet de revenir sur le compte admin en un clic.
 */
const ImpersonationBanner: React.FC = () => {
  const { impersonation, stopImpersonation } = useImpersonation();
  const { adminUsers: ta } = useNotionMessages();
  const navigate = useNavigate();
  const [leaving, setLeaving] = useState(false);

  if (!impersonation) return null;

  const name = impersonation.target.displayName || impersonation.target.email || impersonation.target.id.slice(0, 8);

  const handleExit = async () => {
    setLeaving(true);
    const result = await stopImpersonation();
    setLeaving(false);
    if (result === 'restored') {
      message.success(ta.bannerRestored);
      navigate('/app/admin/users');
    } else {
      message.warning(ta.bannerExpired);
      navigate('/login');
    }
  };

  return (
    <div className="impersonation-banner" role="status">
      <span className="impersonation-banner-icon"><EyeOutlined /></span>
      <div className="impersonation-banner-text">
        <strong>{ta.bannerTitle.replace('{name}', name)}</strong>
        <span>{ta.bannerHint}</span>
      </div>
      <button type="button" className="impersonation-banner-exit" onClick={handleExit} disabled={leaving}>
        <LogoutOutlined /> {ta.bannerExit}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
